import React from "react";
import { BaseCard, SVGIcon } from "../baseCard/baseCard.tsx";
import {
    getFontSizes,
    getTitleHeight,
    darkenColor,
} from "../baseCard/BaseCardUtils.ts";
import "./InstitutionCard.css";

interface InstitutionCardProps {
    category: string;
    title: string;
    subtitle1: string;
    score1: number; // 1-5
    subtitle2: string;
    score2: number; // 1-5
    subtitle3: string;
    score3: number; // 1-5
    subtitle4: string;
    score4: number; // 1-5
    highlight?: boolean;
}

const InstitutionCard: React.FC<InstitutionCardProps> = ({
    category,
    title,
    subtitle1,
    score1,
    subtitle2,
    score2,
    subtitle3,
    score3,
    subtitle4,
    score4,
    highlight = false,
}) => {
    const fontSizes = getFontSizes(highlight);
    const titleHeight = getTitleHeight(highlight);
    const color = "var(--color-light-gray)";
    const shapeColor = darkenColor(color);

    const renderDots = (score: number) => {
        const dots = [];
        for (let i = 0; i < 5; i++) {
            dots.push(
                <div
                    key={i}
                    className={`institutionCard-dot ${i <= score / 20 ? "institutionCard-dot-filled" : ""}`}
                />
            );
        }
        return dots;
    };

    const svgPaths = {
        topShape:
            "M20.7637 1.11044e-05C9.71799 1.24175e-05 0.76368 8.95433 0.763673 20L0.763678 97.4131C9.37694 104.498 32.5399 112.037 67.7002 90.1162C103.94 67.5225 112.736 17.7127 114.172 0L20.7637 1.11044e-05Z",
        bottomShape:
            "M206.493 109.598C206.493 120.643 197.539 129.598 186.493 129.598H0.626953C8.79625 105.382 42.9206 56.9502 114.063 56.9502C185.206 56.9502 205.326 19.2817 206.493 0.447266V109.598Z",
    }


    return (
        <BaseCard highlight={highlight} color={color} className="institutionCard-card">
            <SVGIcon
                className="baseCard-icon-top-right"
                viewBox="0 0 115 105"
                fillColor={shapeColor}
                path={svgPaths.topShape}
            />

            <SVGIcon
                className="baseCard-icon-bottom-left"
                viewBox="0 0 207 130"
                fillColor={shapeColor}
                path={svgPaths.bottomShape}
            />

            <div className="baseCard-content institutionCard-content">
                <div className="institutionCard-header">
                    <div
                        className="institutionCard-category"
                        style={{ fontSize: fontSizes.category }}
                    >
                        {category.toUpperCase()}
                    </div>

                    <div
                        className="institutionCard-title"
                        style={{
                            fontSize: fontSizes.title,
                            height: titleHeight,
                        }}
                    >
                        {title}
                    </div>

                    <div
                        className="baseCard-divider institutionCard-divider"
                        style={{
                            width: "calc(100% + 2 * var(--spacing-3))",
                        }}
                    ></div>
                </div>

                <div className="institutionCard-main-content">
                    <div className="institutionCard-score-section">
                        <div className="institutionCard-score-header">
                            <span
                                className="institutionCard-subtitle2"
                                style={{ fontSize: fontSizes.listItem }} >
                                {subtitle1}
                            </span>
                            <span
                                className="institutionCard-subtitle2"
                                style={{ fontSize: fontSizes.listItem }} >
                                {score1}{"%"}
                            </span>
                        </div>

                        <div className="institutionCard-dots-container">{renderDots(score1)}</div>
                        <div className="institutionCard-thin-divider"></div>
                    </div>
                    <div className="institutionCard-score-section">
                        <div className="institutionCard-score-header">
                            <span
                                className="institutionCard-subtitle2"
                                style={{ fontSize: fontSizes.listItem }} >
                                {subtitle2}
                            </span>
                            <span
                                className="institutionCard-subtitle2"
                                style={{ fontSize: fontSizes.listItem }} >
                                {score2}{"%"}
                            </span>
                        </div>

                        <div className="institutionCard-dots-container">{renderDots(score2)}</div>

                    </div>
                    <div className="institutionCard-thin-divider"></div>

                    <div className="institutionCard-score-section">
                        <div className="institutionCard-score-header">
                            <span
                                className="institutionCard-subtitle2"
                                style={{ fontSize: fontSizes.listItem }} >
                                {subtitle3}
                            </span>
                            <span
                                className="institutionCard-subtitle2"
                                style={{ fontSize: fontSizes.listItem }} >
                                {score3}{"%"}
                            </span>
                        </div>

                        <div className="institutionCard-dots-container">{renderDots(score3)}</div>

                    </div>
                    <div className="institutionCard-thin-divider"></div>
                    <div className="institutionCard-score-section">
                        <div className="institutionCard-score-header">
                            <span
                                className="institutionCard-subtitle2"
                                style={{ fontSize: fontSizes.listItem }} >
                                {subtitle4}
                            </span>
                            <span
                                className="institutionCard-subtitle2"
                                style={{ fontSize: fontSizes.listItem }} >
                                {score4}{"%"}
                            </span>
                        </div>

                        <div className="institutionCard-dots-container">{renderDots(score4)}</div>

                    </div>
                </div>
            </div>
        </BaseCard>
    );
};

export default InstitutionCard
